export const SearchIcon = ({ size = 28 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    aria-label="Search"
  >
    <rect x="12.8333" y="3.5" width="2.33333" height="2.33333" fill="white" />
    <rect
      x="15.1667"
      y="22.1667"
      width="2.33333"
      height="2.33333"
      transform="rotate(180 15.1667 22.1667)"
      fill="white"
    />
    <rect x="10.5" y="3.5" width="2.33333" height="2.33333" fill="white" />
    <rect x="5.83333" y="8.16675" width="2.33333" height="2.33333" fill="white" />
    <rect x="5.83333" y="5.83325" width="2.33333" height="2.33333" fill="white" />
    <rect x="8.16667" y="5.83325" width="2.33333" height="2.33333" fill="white" />
    <rect x="3.5" y="10.5" width="2.33333" height="2.33333" fill="white" />
    <rect
      x="19.8333"
      y="17.5"
      width="2.33333"
      height="2.33333"
      transform="rotate(180 19.8333 17.5)"
      fill="white"
    />
    <rect
      x="19.8333"
      y="19.8333"
      width="2.33333"
      height="2.33333"
      transform="rotate(180 19.8333 19.8333)"
      fill="white"
    />
    <rect
      x="22.1667"
      y="22.1667"
      width="2.33333"
      height="2.33333"
      transform="rotate(180 22.1667 22.1667)"
      fill="white"
    />
    <rect
      x="24.5"
      y="24.5"
      width="2.33333"
      height="2.33333"
      transform="rotate(180 24.5 24.5)"
      fill="white"
    />
    <rect
      x="17.5"
      y="19.8333"
      width="2.33333"
      height="2.33333"
      transform="rotate(180 17.5 19.8333)"
      fill="white"
    />
    <rect x="3.5" y="12.8333" width="2.33333" height="2.33333" fill="white" />
    <rect x="15.1667" y="5.83325" width="2.33333" height="2.33333" fill="white" />
    <rect x="17.5" y="5.83325" width="2.33333" height="2.33333" fill="white" />
    <rect x="17.5" y="8.16675" width="2.33333" height="2.33333" fill="white" />
    <rect
      x="10.5"
      y="19.8333"
      width="2.33333"
      height="2.33333"
      transform="rotate(180 10.5 19.8333)"
      fill="white"
    />
    <rect
      x="8.16667"
      y="19.8333"
      width="2.33333"
      height="2.33333"
      transform="rotate(180 8.16667 19.8333)"
      fill="white"
    />
    <rect
      x="8.16667"
      y="17.5"
      width="2.33333"
      height="2.33333"
      transform="rotate(180 8.16667 17.5)"
      fill="white"
    />
    <rect
      x="12.8333"
      y="22.1667"
      width="2.33333"
      height="2.33333"
      transform="rotate(180 12.8333 22.1667)"
      fill="white"
    />
    <rect x="19.8333" y="10.5" width="2.33333" height="2.33333" fill="white" />
    <rect x="19.8333" y="12.8333" width="2.33333" height="2.33333" fill="white" />
  </svg>
);
